import api from './api';

export interface User {
  id: number;
  name: string;
  company: string;
  department: string;
  email: string;
  role: 'admin' | 'editor' | 'reviewer' | 'viewer';
  createdAt: string;
  updatedAt: string;
}

export interface UpdateUserRoleDto {
  role: 'admin' | 'editor' | 'reviewer' | 'viewer';
}

export interface UserPermission {
  id: number;
  userId: number;
  companyName: string;
  pageType: 'APT' | 'DLP' | 'NAC';
}

export const usersService = {
  getAll: async (): Promise<User[]> => {
    const response = await api.get<User[]>('/users');
    return response.data;
  },

  updateRole: async (userId: number, role: UpdateUserRoleDto): Promise<User> => {
    const response = await api.patch<User>(`/users/${userId}/role`, role);
    return response.data;
  },

  getUserPermissions: async (userId: number): Promise<UserPermission[]> => {
    const response = await api.get<UserPermission[]>(`/users/${userId}/permissions`);
    return response.data;
  },

  setUserPermissions: async (
    userId: number,
    permissions: Array<{ companyName: string; pageType: 'APT' | 'DLP' | 'NAC' }>,
  ): Promise<UserPermission[]> => {
    const response = await api.post<UserPermission[]>(`/users/${userId}/permissions`, {
      permissions,
    });
    return response.data;
  },

  delete: async (userId: number): Promise<void> => {
    await api.delete(`/users/${userId}`);
  },

  resetPassword: async (userId: number): Promise<{ message: string; tempPassword?: string }> => {
    const response = await api.post<{ message: string; tempPassword?: string }>(
      `/users/${userId}/reset-password`,
    );
    return response.data;
  },
};

